import store from '../store/store';

export default function getGroupSets() {
    return store.userConfiguration?.GroupsSets;
}
